'use client';

import type { ReactNode } from 'react';
import { Box } from '@terra/ui-styled-system';
import { useObjectEditMeasureLayout } from './objectEditMeasureContext';

export type ObjectEditFieldGroupProps = {
  children: ReactNode;
};

export function ObjectEditFieldGroup({ children }: ObjectEditFieldGroupProps) {
  const isTwoColumnLayout = useObjectEditMeasureLayout();

  return (
    <Box
      w="full"
      minW={0}
      p={4}
      bg="bg.default"
      borderRadius="lg"
      display="grid"
      gridTemplateColumns={
        isTwoColumnLayout ? 'repeat(2, minmax(0, 1fr))' : '1fr'
      }
      gap={4}
      alignItems="start"
    >
      {children}
    </Box>
  );
}

export type ObjectEditFieldProps = {
  children: ReactNode;
  span?: 'full';
};

export function ObjectEditField({ children, span }: ObjectEditFieldProps) {
  return (
    <Box minW={0} w="full" gridColumn={span === 'full' ? '1 / -1' : undefined}>
      {children}
    </Box>
  );
}
